import React from 'react';
import { Box } from '@mui/material';
import { ReactComponent as AkrosIconMark } from '../assets/Icons/akros_icon.svg';
import { ReactComponent as AkrosNameMark } from '../assets/Icons/akros_name.svg';

const AkrosLogo = ({
  showName = true,
  iconColor = 'currentColor',
  nameColor = 'currentColor',
  iconSize = 28,
  height = 32,
  gap = 10,
  sx = {}
}) => (
  <Box
    aria-label="Akros"
    role="img"
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: `${gap}px`,
      lineHeight: 0,
      color: iconColor,
      ...sx
    }}
  >
    <AkrosIconMark
      style={{
        width: iconSize,
        height: iconSize,
        color: iconColor,
        flex: '0 0 auto'
      }}
    />
    {showName && (
      <AkrosNameMark
        style={{
          height,
          width: 'auto',
          maxWidth: '100%',
          color: nameColor,
          flex: '1 1 auto'
        }}
      />
    )}
  </Box>
);

export default AkrosLogo;
